var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, QueryList } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { HsgFieldInput } from '../../../../node_modules/hsg';
var AuthUserDetailsComponent = /** @class */ (function (_super) {
    __extends(AuthUserDetailsComponent, _super);
    function AuthUserDetailsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginOriginAction = "";
        return _this;
    }
    AuthUserDetailsComponent.prototype.ngOnInit = function () {
        sessionStorage.removeItem("checkOpenCalls");
        sessionStorage.setItem("currentWindow", "כניסה למידע אישי");
        this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
    };
    AuthUserDetailsComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            //console.log("sent parametes", { UserId: form.value.uid, FullPhone: form.value.phone });
            this.authUserService.sendAuthData("ValidateUser", { UserId: form.value.uid, FullPhone: form.value.phone })
                .subscribe(function (res) {
                if (res.Details.hasOpenContactCalls) {
                    sessionStorage.setItem("checkOpenCalls", "hasOpenCalls");
                }
                _this.modalService.close(res.Details);
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    return AuthUserDetailsComponent;
}(AuthBaseComponent));
export { AuthUserDetailsComponent };
